import { useQuery } from '@tanstack/react-query';

import { eventJournalApi } from '@entities/eventJournal/api';

export const useGetJournalEventsContext = () => {
    const { data, isSuccess, isPending } = useQuery({
        ...eventJournalApi.getJournalEventsContextQueryOptions(),
    });

    return {
        data,
        isSuccess,
        isPending,
    };
};
